// extracted by mini-css-extract-plugin
export default {"wrapper":"V8-z"};